import React from "react";
import { AccessBox } from "../../containers/settings";

export const AccessPage = () => {
  return (
    <div>
      <AccessBox />
    </div>
  );
};
